// Hero Carousel Component
// Depends on window.Splide and window.SplideIntersection (exposed from legacy-global.js)

if (!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class GlobalHeroBanner extends HTMLElement {
      constructor() {
        super();
        this.interval = this.getAttribute('interval');
      }

      connectedCallback() {
        const Splide = window.Splide;
        const Intersection = window.SplideIntersection;

        const isAutoplay = Shopify.designMode ? false : true;
        const splide = new Splide(this, {
          type: 'fade',
          rewind: true,
          autoplay: isAutoplay,
          interval: this.interval,
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: true,
          classes: {
            pagination: 'splide__pagination global-hero-carousel lg:px-12',
            page: 'splide__pagination__page'
          }
        });

        splide.mount({ Intersection });

        document.addEventListener('shopify:section:load', (event) => {
          splide.refresh();
        });

        document.addEventListener('shopify:block:select', (event) => {
          const target = event.target;
          const isSlide = target.classList.contains('splide__slide');
          if (isSlide) {
            const index = target.getAttribute('aria-label').charAt(0);
            splide.go(parseInt(index) - 1);
          }
        });

        splide.on('active', function (event) {
          const slide = event.slide;
          const video = slide.querySelector('video');
          if (video != undefined) {
            video.play();
          }
        });

        splide.on('inactive', function (event) {
          const slide = event.slide;
          const video = slide.querySelector('video');
          if (video != undefined) {
            video.pause();
          }
        });
      }
    }
  );
}
